import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonApi } from './api/common.api';
import { CommonService } from './common.service';
import { ApiUrls } from 'src/app/config/constants';
import { environment } from 'src/environments/environment';
import { ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  updateOrderItem: any;

  private url = {
    getOrder: "/rms/apis/v1/orders?status=",
    getOrderById: "/rms/apis/v1/orders/",
    updateOrderStatus: (orderId: any) =>
      `/rms/apis/v1/orders/${orderId}/status`,
    updatePayment: (orderId: any) => `/rms/apis/v1/orders/${orderId}/payment`,
  }



  constructor(
    private commonApi: CommonApi,
    private commonService: CommonService,
  ) { }

  getDelBoyList() {
    return this.commonApi.getData(`${ApiUrls.getDboyList}`).pipe(catchError((err) => this.errorHandler(err)));
  }

  selectDeliveryBoy(orderId: any, body: any) {
    return this.commonApi.postData(ApiUrls.assignOrder(orderId), body).pipe(catchError((err) => this.errorHandler(err)));
  }

  selectReDeliveryBoy(orderId: any, body: any) {
    return this.commonApi.postData(ApiUrls.reAssignOrder(orderId), body).pipe(catchError((err) => this.errorHandler(err)));
  }

  getOrderStatusWise(status: string, limit?, offset?, deliveryDate?, orderQuery?, isB2b?: boolean) {
    orderQuery == undefined ? orderQuery = '' : orderQuery;
    limit == undefined ? limit = '' : limit;
    offset == undefined ? offset = '' : offset;
    deliveryDate == undefined ? deliveryDate = '' : deliveryDate;
    orderQuery == undefined ? orderQuery = '' : orderQuery;
    if (isB2b == true || isB2b == false) {
      return this.commonApi.getDataByUrl(environment.baseUrl + ApiUrls.getOrder + status + `&limit=${limit}&offset=${offset}&deliveryDate=${deliveryDate}&orderQuery=${orderQuery}&isB2b=${isB2b}`).pipe(catchError((err) => this.errorHandler(err)));
    }
    return this.commonApi.getDataByUrl(environment.baseUrl + ApiUrls.getOrder + status + `&limit=${limit}&offset=${offset}&deliveryDate=${deliveryDate}&orderQuery=${orderQuery}`).pipe(catchError((err) => this.errorHandler(err)));
  }

  getOrderByIdDetails(orderId: string) {
    return this.commonApi.getDataByUrl(environment.baseUrl + this.url.getOrderById + orderId).pipe(catchError((err) => this.errorHandler(err)));
  }

  updateOrderStatus(orderId: any, body: any) {
    return this.commonApi.putData(ApiUrls.updateOrderStatus + `${orderId}/status`, body).pipe(catchError((err) => this.errorHandler(err)));
  }

  updatePaymentStatus(orderId: any, body: any) {
    return this.commonApi.putData(ApiUrls.updatePayment + `${orderId}/payment`, body).pipe(catchError((err) => this.errorHandler(err)));
  }

  updateQuantity(orderId: any) {
    return this.commonApi.putData(ApiUrls.updateQuantity, orderId).pipe(catchError((err) => this.errorHandler(err)));
  }

  autoAssignDeliveryBoy(orderId: string) {
    return this.commonApi.postData(ApiUrls.autoAssignOrder(orderId), "").pipe(catchError((err) => this.errorHandler(err)));
  }

  getOrderDetails(orderId: string) {
    //return this.http.get(this.url.getOrderById)
    return this.commonApi.getDataByUrl(this.url.getOrderById).pipe(catchError((err) => this.errorHandler(err)));
  }

  orderReAssign(orderId: string) {
    const data = { orderId };
    return this.commonApi.postData(ApiUrls.orderReAssign, data).pipe(catchError((err) => this.errorHandler(err)));
  }

  autoAssignScheduleDeliveryBoy(orderId: string, data: any) {
    return this.commonApi.postData(ApiUrls.autoAssignOrder(orderId), data).pipe(catchError((err) => this.errorHandler(err)));
  }

  private errorHandler(err: any) {
    if (err.error.length >= 1) {
      this.commonService.toast(err.error[0].message);
    } else {
      this.commonService.toast(err.error.error.message);
    }
    return throwError(err);
  }
}
